import { Button, ComboBox, Icons, TextInput } from '@components';
import { banks } from '@utils';
import { Field } from 'formik';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { obterFormulariosRequest } from '../../../../store/modules/requerimento/actions';

const REFERENCIA_DADOS_BANCARIOS = 'AtualizacaoDadosBancarios';

export const DadosBancariosForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { allForms: formularios, allFormsRequestDone } = useSelector(
    (state) => state.requerimento
  );

  const formularioDadosBancarios = useMemo(
    () => formularios.find((f) => f.referencia === REFERENCIA_DADOS_BANCARIOS),
    [formularios]
  );

  const isDadosBancariosHabilitado =
    formularioDadosBancarios?.habilitado ?? false;

  useEffect(() => {
    if (!allFormsRequestDone) {
      dispatch(obterFormulariosRequest());
    }
  }, [allFormsRequestDone, dispatch]);

  const handleIrParaRequerimento = () => {
    if (isDadosBancariosHabilitado && formularioDadosBancarios) {
      navigate(`/requerimentos/novo/${formularioDadosBancarios.destino}`);
    }
  };

  return (
    <div className="row">
      <div className="col-12 col-md-6">
        <Field
          name="banco"
          disabled
          className="mb-3"
          component={ComboBox}
          label="Banco"
          options={banks.map((s) => {
            return {
              value: s.codigo,
              label: `${s.codigo} - ${s.banco}`,
            };
          })}
        />
      </div>
      <div className="col-4 col-md-1">
        <Field
          type="number"
          disabled
          name="agencia"
          noPadding
          component={TextInput}
          label="Agência"
        />
      </div>
      <div className="col-5 col-md-2 px-0">
        <Field
          name="conta"
          disabled
          type="number"
          component={TextInput}
          label="Conta"
        />
      </div>
      <div className="col-3 col-md-1">
        <Field
          name="digito"
          disabled
          type="text"
          noPadding
          component={TextInput}
          label="Digito"
        />
      </div>
      <hr className="my-4" />
      <div
        className="card shadow-sm border-0 p-4"
        style={{ borderRadius: '12px' }}
      >
        <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
          <div>
            <h3 className="fw-bold mb-2">Atualização de Dados Bancários</h3>
            <p className="mb-0 text-muted">
              Para alterar os dados bancários, favor preencher o requerimento de
              Atualização dados bancários clicando no botão ao lado
            </p>
          </div>
          <div className="d-flex flex-column align-items-center flex-shrink-0">
            <Button
              transparent
              color="orange"
              onClick={handleIrParaRequerimento}
              disabled={!isDadosBancariosHabilitado}
            >
              Ir para Requerimento
            </Button>
            {!isDadosBancariosHabilitado && allFormsRequestDone && (
              <div
                className="d-flex align-items-start gap-2 mt-2 p-2"
                style={{
                  backgroundColor: '#fff3e0',
                  borderRadius: '8px',
                  maxWidth: '280px',
                }}
              >
                <Icons
                  path="warning"
                  size={1.2}
                  style={{ color: '#f9a825', flexShrink: 0 }}
                />
                <span className="ts-12 fw-bold" style={{ color: '#f9a825' }}>
                  Para criar um novo requerimento desse tipo é necessário
                  cancelar o requerimento anterior em andamento.
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
